import { type TableColumnWidthInfo } from "@devexpress/dx-react-grid";

export const SELECTION_COLUMN_WIDTH = 49;
export const ROW_HEIGHT = 20;

export const isColumnSortable = (metricName: string) => {
  return true;
};

export const isColumnFilterable = (metricName: string) => {
  if (metricName === FIXED_NAME_COLUMN_ID) {
    return false;
  }

  return true;
};

export const FIXED_NAME_COLUMN_ID = "Name";
export const FIXED_NAME_COLUMN = {
  name: FIXED_NAME_COLUMN_ID,
  id: FIXED_NAME_COLUMN_ID,
  title: "MMM+ CHANNELS",
  width: 258,
};

export const PACING_STATUS_COLUMN_ID = "pacingStatus";
export const PACING_STATUS_COLUMN = {
  name: PACING_STATUS_COLUMN_ID,
  id: PACING_STATUS_COLUMN_ID,
  title: "PACING",
  width: 100,
};

export const SPEND_THERMOMETER_ID = "spendThermometer";
export const SPEND_THERMOMETER_COLUMN = {
  name: SPEND_THERMOMETER_ID,
  id: SPEND_THERMOMETER_ID,
  title: "PACING TO DATE",
  width: 136,
};

export const TOTAL_BUDGET_COLUMN_ID = "totalBudget";
export const TOTAL_BUDGET_COLUMN = {
  name: TOTAL_BUDGET_COLUMN_ID,
  id: TOTAL_BUDGET_COLUMN_ID,
  title: "ADOPTED",
  width: 108,
};
export const TOTAL_BUDGET_PROPOSED_COLUMN_ID = "totalBudgetProposed";
export const TOTAL_BUDGET_PROPOSED_COLUMN = {
  name: TOTAL_BUDGET_PROPOSED_COLUMN_ID,
  id: TOTAL_BUDGET_PROPOSED_COLUMN_ID,
  title: "BUDGET",
  // width: 118,
  width: 144,
};

export const COLUMNS = [
  FIXED_NAME_COLUMN,
  SPEND_THERMOMETER_COLUMN,
  PACING_STATUS_COLUMN,
  TOTAL_BUDGET_COLUMN,
  TOTAL_BUDGET_PROPOSED_COLUMN,
];

export const DEFAULT_COLUMN_WIDTHS: TableColumnWidthInfo[] = COLUMNS.map(
  ({ name, width }) => ({ columnName: name, width }),
);
